import React, { useState } from 'react';
import './login.css'; // Import the CSS file
import { sendOtp, verifyOtp } from '../../service/login-service';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import { ROUTES, STRINGS } from '../../comman/constants';



function Login() {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!validateEmail(email.trim())) {
      setErrors({ email: STRINGS.login.invalidEmail });
      return;
    }
    const data = await sendOtp(email);
    if (data.status === 204) {
      setErrors({});
      setOtpSent(true);
    } else {
      toast.error(data?.response?.data?.message);
    }
  };

  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      if (otp) {
        const data = await verifyOtp(email, otp);
        if (data.status === 200) {
          const accessToken = data?.data?.data?.accessToken;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("route",ROUTES.DASHBOARD);
          navigate(`/${ROUTES.DASHBOARD}`);
        } else {
          toast.error(data?.response?.data?.message);
        }
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <>
      <ToastContainer />
      <h4>
        <title>{STRINGS.login.title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </h4>
      <div className="login-container">
        <div className="login-form">
          <h2 className="login-title">{STRINGS.login.title}</h2>
          {!otpSent ? (
            <form className="form" onSubmit={handleSendOtp}>
              <div className="input-group">
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="input-field"
                  placeholder={STRINGS.login.emailPlaceholder}
                />
              </div>
              {errors.email && <p className="error-text">{STRINGS.login.invalidEmail}</p>}
              <button type="submit" className="submit-button">
                {STRINGS.login.sendOtp}
              </button>
            </form>
          ) : (
            <form className="form" onSubmit={handleLogin}>
              <div className="input-group">
                <input
                  onChange={(e) => setOtp(e.target.value)}
                  value={otp}
                  id="otp"
                  name="otp"
                  type="text"
                  required
                  className="input-field"
                  placeholder={STRINGS.login.otpPlaceholder}
                />
              </div>
              {errors.otp && <p className="error-text">{errors.otp}</p>}
              <button type="submit" className="submit-button">
                {STRINGS.login.login}
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default Login;
